import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pagination" }

import { ref, onMounted, watch, inject } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Customer } from "@/models/customer.model";
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomersPagination',
  setup(__props) {

const store = useStore();
const route = useRoute();
const toast = useToast();
const actProperty: any = inject('actProperty');

const links = [
  "a", "b", "c", "d", "e", "f", "g", "h", "i", "j",
  "k", "l", "m", "n", "o", "p", "q", "r", "s", "t",
  "u", "v", "w", "x", "y", "z", "0-9"
];

const getCustomersAction = (payload?: {
  starts_with?: string;
  company_name?: string;
  branch_name?: string;
}): Promise<Customer[]> => {
  return store.dispatch('customers/getCustomers', payload);
};

const getCustomers = (starts_with: string) => {
    getCustomersAction({ starts_with })
      .catch((err: any) => actProperty.displayError(err));
  }

const init = () => {
  if (route.params.search) {
    getCustomers((route.params.search as string));
  }
};

onMounted(init);

watch(() => route.params.search, (currentSearch, prevSearch) => {
  if (currentSearch !== prevSearch) {
    init();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link, $index) => {
        return _createElementVNode("li", {
          key: $index,
          class: _normalizeClass(["page-item", { active: _ctx.$route.params.search == link }])
        }, [
          _createVNode(_component_router_link, {
            to: { name: 'email-template-clients' , params: {search: link}},
            class: "page-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.toUpperCase()), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 2)
      }), 64))
    ])
  ]))
}
}

})